import Vue from 'vue';
import Vuex from 'vuex';
import { firebase } from './../src/firebase/firebase'
import auth from './../storage/modules/myfirebase-auth/auth'
import Projects from './../storage/modules/projectsstore'
import Account from './../storage/modules/accountstore'
import storage from './../storage/modules/myfirebase-storage/storage'
require('firebase/firestore')

Vue.use(Vuex);

// Cloud Firestore.
const firestore = firebase.firestore();
firestore.settings({})
// Error.
const error = ''

let store = new Vuex.Store({
    // myfirebase modules
    modules: {
        auth: auth,
        storage: storage,
        projects: Projects,
        account: Account
    },
    // states
    state: {
        firestore: firestore,
        error: error,
        firebase: firebase,
    },
    // mutations
    mutations: {},
    // getters
    getters: {},
    //actions
    actions: {}
})


Vue.prototype.$store = store

export default store



// WEBPACK FOOTER //
// ./storage/store.js